import React from 'react'

function AllContacts() {
  return (
    <div>AllContacts</div>
  )
}

export default AllContacts